(function ($, Drupal) {
    Drupal.behaviors.dropdown = {
      attach: function (context, settings) {
        const block = document.querySelectorAll('.block-sidebar-products');
        var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        if (width < 747) {
          block.forEach(function (element) {
            const blockSidebar = element.closest('.block-sidebar-products');
            blockSidebar.classList.toggle('block__open');
          });

          var blockSectionOne = document.querySelector('.facets-widget-links');
          var blockSectionTwo = document.querySelector('.facets-widget-range_slider');
          var blockSectionThree = document.querySelector('.facets-widget-checkbox');
          blockSectionOne.classList.toggle('block__section__open');
          blockSectionOne.style.display = 'none';
          blockSectionTwo.classList.toggle('block__section__open');
          blockSectionTwo.style.display = 'none';
          blockSectionThree.classList.toggle('block__section__open');
          blockSectionThree.style.display = 'none';
        }

        if (block && block.length > 0) {
          block.forEach(function (element) {
            var dropdownButton = element.querySelectorAll('h2');
            if (dropdownButton && dropdownButton.length) {
              dropdownButton.forEach(function (element){
                element.addEventListener('click', openBlock);
              });
            }
          });
        }
      }
    };
  
    function openBlock(e) {
      e.stopPropagation();
      const currentBlock = this.closest('.block-sidebar-products');
      if (currentBlock.classList.contains('block__open')) {
        closeSidebar(this);
      } else {
        var blockSection = currentBlock.querySelector('.facets-widget-links');

        if (blockSection == null) {
          blockSection = currentBlock.querySelector('.facets-widget-range_slider');

          if (blockSection == null) {
            blockSection = currentBlock.querySelector('.facets-widget-checkbox');
          }
        }

        currentBlock.classList.toggle('block__open');
        blockSection.classList.toggle('block__section__open');
        blockSection.style.display = 'block';
      }
    }
  
    function closeSidebar(element) {
      const currentBlock = element.closest('.block-sidebar-products');
      var blockSection = currentBlock.querySelector('.facets-widget-links');

      if (blockSection == null) {
        blockSection = currentBlock.querySelector('.facets-widget-range_slider');

        if (blockSection == null) {
          blockSection = currentBlock.querySelector('.facets-widget-checkbox');
        }
      }

      currentBlock.classList.toggle('block__open');
      blockSection.classList.toggle('block__section__open');
      blockSection.style.display = 'none';
    }
  })(jQuery, Drupal);
  